
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import socket from './../socket.js'

function GetCode (){
  const [code,setCode] = useState ("");
  const navigate = useNavigate ();
  const location = useLocation ();
  const phone = location.state.phone;
  useEffect (()=>{
    if (!socket)return;

    socket.on ('message',(data)=>{
      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
      if (data.event==='code_send') window.alert(data.data);
    });
    socket.on ('message',(data)=>{
      const da=JSON.parse(data);
      if (da.event=='code_ok')
      {
        if (da.data!=null && da.data._id!=null)
        {
          if (da.data.boards!=null)
          {
            localStorage.setItem('id',da.data._id);
            localStorage.setItem('phone', phone);
            localStorage.setItem('boards', JSON.stringify(da.data.boards));
            localStorage.setItem('select_board', '0');

            navigate ("/MainApp");


    //      saveData (data);

          }else{
            window.alert ('شما به هیچ دستگاهی دسترسی ندارید')
            navigate ("/GetPhone");

      //    navigation.goBack();
          }
        }else {
          window.alert ('کد وارد شده اشتباه است')
        }
      }

    })



  return () =>{
    socket.off ('message');
  };

},[socket]);


  return (
    <div style={style.container}>
      <div style={style.content}>
        <h2 style={style.text}>
          لطفا کد پیامک را وارد نمایید
        </h2>
        <input style={style.input}
        type="tel"
        placeholder = "------"
        value={code}
        onChange = {(e)=>{setCode (e.target.value)}}/>
      <button style={style.button}
        onClick ={()=>{
          if (code.length==6)
      //      socket.emit ('myCode',{"code":code});
            socket.emit ('myCode',{"phone":phone,"code":code})
          else
            window.alert ('کد وارد شده اشتباه است')

        }}>
         ارسال کد
      </button>
    </div>
    </div>
  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default GetCode;
